import { useConnectionStore } from '@/store/connectionStore';
import { Wifi, Loader2, AlertTriangle, ShieldCheck, WifiOff } from 'lucide-react';

export function ConnectionStatus() {
  const { rtcState, wsState, isRelay } = useConnectionStore();

  let label = 'Offline';
  let badgeClass = 'text-cinema-400 bg-cinema-800/80 border-cinema-700/60';
  let dotClass = 'bg-cinema-500';
  let Icon = Wifi;

  if (wsState === 'connecting') {
    label = 'Connecting…';
    badgeClass = 'text-amber-400 bg-amber-500/10 border-amber-500/30';
    dotClass = 'bg-amber-400 animate-pulse';
    Icon = Loader2;
  } else if (wsState === 'connected' && rtcState === 'idle') {
    label = 'Room Ready';
    badgeClass = 'text-cinema-300 bg-cinema-800 border-cinema-700';
    dotClass = 'bg-lamp';
  } else if (rtcState === 'connecting') {
    label = 'Connecting stream…';
    badgeClass = 'text-amber-400 bg-amber-500/10 border-amber-500/30';
    dotClass = 'bg-amber-400 animate-pulse';
    Icon = Loader2;
  } else if (rtcState === 'connected') {
    if (isRelay) {
      label = 'Connected (Relay)';
      badgeClass = 'text-amber-300 bg-amber-500/10 border-amber-500/30';
      dotClass = 'bg-amber-400';
      Icon = ShieldCheck;
    } else {
      label = 'Direct Connected';
      badgeClass = 'text-reel-emerald bg-reel-emerald/10 border-reel-emerald/30';
      dotClass = 'bg-reel-emerald';
      Icon = Wifi;
    }
  } else if (rtcState === 'reconnecting') {
    label = 'Reconnecting…';
    badgeClass = 'text-amber-400 bg-amber-500/10 border-amber-500/30';
    dotClass = 'bg-amber-400 animate-pulse';
    Icon = Loader2;
  } else if (rtcState === 'failed' || rtcState === 'disconnected') {
    label = 'Disconnected';
    badgeClass = 'text-reel-rose bg-reel-rose/10 border-reel-rose/30';
    dotClass = 'bg-reel-rose';
    Icon = WifiOff;
  }

  return (
    <div
      className={`inline-flex items-center gap-2 px-2.5 py-1 rounded-md text-xs font-medium border ${badgeClass}`}
      title={`Connection: ${label}`}
    >
      <span className={`w-2 h-2 rounded-full ${dotClass}`} />
      <span className="tracking-tight">{label}</span>
    </div>
  );
}
